export const getValidityOfConsents = (consents: boolean[]) => {
    return !consents.some((consent: boolean) => !consent);
};
